import { API_RESEND_DOUBLE_OPT_IN_MAIL_URL } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";

export const useResendDoubleOptInEmailMutation = () => {
    return useMutation(API_RESEND_DOUBLE_OPT_IN_MAIL_URL);
};

export type IResendDoubleOptInEmailMutation = ReturnType<typeof useResendDoubleOptInEmailMutation>;
